import { digitGroup } from 'src/helpers/index'
import { commonDate } from 'src/helpers/date'

export default function () {
  return {
    table: {
      list: {
        visibleColumns: [
          'name',
          'referal',
          'phone',
          'totalOrder',
          'totalTransaction',
          'commission'
        ],

        columns: [
          {
            name: 'name',
            field: row => {
              return row.name
            },
            label: 'Nama',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'referal',
            field: row => {
              return row.referal
            },
            label: 'Kode Referal',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'phone',
            field: row => {
              return `<a href="tel:${row.phone}">${row.phone}</a>`
            },
            label: 'No. Telpon',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'totalOrder',
            field: row => {
              return digitGroup(row.total_payment)
            },
            label: 'Total Order',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'totalTransaction',
            field: row => {
              return `Rp ${digitGroup(row.total_trans)}`
            },
            label: 'Total Transaksi',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'commission',
            field: row => {
              return `Rp ${digitGroup(row.total_commission)}`
            },
            label: 'Total Komisi',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          }
        ]
      },

      commission: {
        columns: [
          {
            name: 'name',
            field: row => {
              return row.name
            },
            label: 'Nama Kategori 1',
            sortable: false,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'commission',
            field: row => {
              return row.commission
            },
            label: 'Persentase Komisi Sales',
            sortable: false,
            align: 'center',
            rowClass: 'text-center'
          }
        ]
      },

      perform: {
        columns: [
          {
            name: 'so_no',
            field: row => {
              // return row.so_no
              return `
              <a
                href="/so/detail/${
                    row.so_id
                  }/${encodeURIComponent(
                    row.so_no
                  )}"
                class="goto-preview-page text-primary"
              >
                <span class="text-weight-bold">${row.so_no}</span>
              </a>`
            },
            label: 'No. Sales Order',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'customer_name',
            field: row => {
              return row.customer_name
            },
            label: 'Customer',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'created_at',
            field: row => {
              return commonDate({
                date: row.created_at,
                useDayName: true
              })
            },
            label: 'Tanggal Transaksi',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'total_payment',
            field: row => {
              return 'Rp ' + digitGroup(row.total_payment)
            },
            label: 'Total Pembelian',
            sortable: false,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'total_commission',
            field: row => {
              return 'Rp ' + digitGroup(row.total_commission)
            },
            label: 'Total Komisi',
            sortable: false,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'customer_address',
            field: row => {
              return `<div class="ellipsis" style="max-width: 300px">${row.customer_address}</div>`
            },
            label: 'Alamat Pengiriman',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          },
          {
            name: 'status',
            field: row => {
              // return row.status
              return `<div
              role="alert"
              class="q-badge flex inline items-center no-wrap q-badge--single-line bg-teal-1 text-primary q-px-sm"
              >${row.status}</div>`
            },
            label: 'Status Transaksi',
            sortable: true,
            align: 'center',
            rowClass: 'text-center'
          }
        ]
      }
    }
  }
}
